import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import WizardStepLayout from 'Views/Page/Content/Modal/Layouts/WizardStepLayout';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';


const useStyles = buildUseStyles('MoveManagedAccountTemplate', () => ({
  root: {},
}));

const WizardTemplateWithMetaOverride = ({
  className,
  resource,
  overrideSet,
  primaryActionLabel,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      resource={resource}
      layout={WizardStepLayout}
      primaryActionLabel={primaryActionLabel}
      LayoutProps={{
        resource,
      }}
      metaOverrideSet={overrideSet}
    />
  );
};

WizardTemplateWithMetaOverride.defaultProps = {
  className: '',
  overrideSet: BaseWizardStepOverride,
  primaryActionLabel: undefined,
};

WizardTemplateWithMetaOverride.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  overrideSet: PropTypes.object,
  primaryActionLabel: PropTypes.string,
};

export default WizardTemplateWithMetaOverride;
